import { StandardProps } from "../componentMap";
import { UserAcknowledgementUI } from "./UserAcknowledgementUI";

export function UserAcknowledgement({
  product,
}: Pick<StandardProps, "product">) {
  const { termsAndConditions } = product;

  if (!termsAndConditions?.customerConfirmationRequired) return null;

  return <UserAcknowledgementUI terms={termsAndConditions?.detail} />;
}
